const getDefaultState = () => {
    return {
        language: null,
        user: null,
        secondaryEmail: {},
        company: null,
        frontEndSettings: {},
    }
}

const state = getDefaultState()

const getters = {
    userLanguage(state: any) {
        return state.language
    },

    // USER
    user(state: any) {
        return state.user
    },

    isSuperuser(state: any) {
        return state.user ? state.user.attributes.isSuperuser : false
    },

    // SECONDARY EMAIL
    secondaryEmails(state: any) {
        return state.secondaryEmail
    },

    secondaryEmail: (state: any) => (id: string) => {
        return state.secondaryEmail[id]
    },

    // COMPANY
    userCompany(state: any) {
        return state.company
    },

    // FRONT END SETTINGS
    frontEndSettings(state: any) {
        return state.frontEndSettings
    },
}

const mutations = {
    userLanguage(state: any, payload: any) {
        state.language = payload
    },

    // USER
    user(state: any, payload: any) {
        state.user = payload

        if (payload) {
            state.language = payload.attributes.language
        }
    },

    // SECONDARY EMAIL
    secondaryEmails(state: any, payload: any) {
        state.secondaryEmail = payload
    },

    // COMPANY
    userCompany(state: any, payload: any) {
        state.company = payload
    },

    // FRONT END SETTINGS
    frontEndSettings(state: any, payload: any) {
        state.frontEndSettings = payload
    },

    //RESET
    resetUser(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
